import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { DetailedTag } from 'src/services/tag/DetailedTag';
import { Tag } from 'src/services/tag/Tag';
import { getTagColor } from 'src/utils/getTagColor';
import { getTopLevelTag } from 'src/utils/getTopLevelTag';
import { trackByTagId } from 'src/utils/trackByTagId';

@Component({
  selector: 'tag-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss'],
})
export class TagListComponent {
  @Input() tags: DetailedTag[] = [];
  @Input() allTags: DetailedTag[] = [];
  @Input() wrap = false;
  @ViewChild('container') containerRef!: ElementRef;

  visibleTags: Tag[] = [];
  hiddenCount: number = 0;
  isInitialized = false;

  getTagColor = getTagColor;
  trackByTagId = trackByTagId;

  constructor(private changeRef: ChangeDetectorRef, public router: Router) {}

  ngAfterViewInit() {
    this.updateView();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateView();
  }

  updateView() {
    setTimeout(() => {
      this.visibleTags = this.tags;

      this.updateVisibleTags();
    });
  }

  private readonly HIDDEN_COUNTER_WIDTH = 20;

  private updateVisibleTags() {
    setTimeout(() => {
      if (!this.containerRef) return;

      const container = this.containerRef.nativeElement;
      const containerWidth = container.offsetWidth;
      let currentWidth = 0;

      const tagElements = container.querySelectorAll('.tag');
      const newVisibleTags: Tag[] = [];
      for (let i = 0; i < tagElements.length; i++) {
        const tagWidth = tagElements[i].offsetWidth;

        if (
          currentWidth + tagWidth >
          containerWidth - this.HIDDEN_COUNTER_WIDTH
        )
          break;
        currentWidth += tagWidth + 8; // Adding 8px for gap
        newVisibleTags.push(this.tags[i]);
      }

      this.visibleTags = newVisibleTags;
      this.hiddenCount = Math.max(
        0,
        this.tags.length - this.visibleTags.length
      );
      this.isInitialized = true;
    });
  }

  navigateToTag(tag: Tag) {
    this.router.navigate(['/tags/' + tag.fullPath]);
  }

  getTopLevelTag(tag: Tag): Tag | undefined {
    return getTopLevelTag(tag, this.allTags);
  }
}
